import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { User } from 'src/app/data/model/user';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class PasswordResetApiService extends CrudApiService<User> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('rest-auth/password/change/', http, config);
  }
}

